import { Repair, RepairFilters, RepairMeta, RepairResponse } from "../../interfaces";
import { RepairRepository } from "../repositories";
export class RepairProcess {
    private repairRepository: RepairRepository;

    constructor() {
        this.repairRepository = new RepairRepository();
    }

    async createRepair(data: { orderId: string, measurementsId: string, email: string, price: number }): Promise<{ message: string }> {
        const response = await this.repairRepository.createRepair(data);
        return { message: response.data.message };
    }

    async getRepairs(filters: RepairFilters): Promise<RepairResponse> {
        const response = await this.repairRepository.getRepairs(filters);
        const {
            data: { data, meta },
        } = response;
        return {
            data: data,
            meta: meta,
        };
    }

    async getRepairById(repairId: string): Promise<Repair> {
        const response = await this.repairRepository.getRepairById(repairId);
        return response.data;
    }

    async updateRepairStatus(repairId: string, location?: string): Promise<{ message: string }> {
        const response = await this.repairRepository.updateRepairStatus(repairId, location);
        return { message: response.data.message };
    }

    async addRepairNote(repairId: string, note: string): Promise<{ message: string }> {
        const response = await this.repairRepository.addRepairNote(repairId, note);
        return { message: response.data.message };
    }

    async associateRepairFiles(repairId: string, formData: any): Promise<{ message: string }> {
        const response = await this.repairRepository.associateRepairFiles(repairId, formData);
        return { message: response.data.message };
    }

    async generateRepToWellingtonLabel(repairId: string): Promise<{ message: string }> {
        const response = await this.repairRepository.generateRepToWellingtonLabel(repairId);
        return { message: response.data.message };
    }

    async generateCustomerToWellingtonLabel(repairId: string): Promise<{ message: string }> {
        const response = await this.repairRepository.generateCustomerToWellingtonLabel(repairId);
        return { message: response.data.message };
    }
}
